import { render, staticRenderFns } from "./likes.vue?vue&type=template&id=7474ab32"
import script from "./likes.vue?vue&type=script&lang=js"
export * from "./likes.vue?vue&type=script&lang=js"
import style0 from "./likes.vue?vue&type=style&index=0&id=7474ab32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports